<script
  lang="ts"
  setup
  generic="
    T extends {
      [key: string]: string | number;
    },
    K extends keyof T
  "
>
import { GpTag } from '@gportal/uikit';
import getEnumLabel from 'gpcore-apikit/lib/getEnumLabel';
import { computed } from 'vue';

type StatusType = 'neutral' | 'success' | 'warning' | 'danger' | 'info';
const props = withDefaults(
  defineProps<{
    enumMap: T;
    enumValue: T[K];
    status?: StatusType;
    /**
     * Map enum values to status types
     *
     * Example:
     *
     * ```typescript
     * {
     *  0: 'neutral',
     *  1: 'success',
     * }
     * ```
     */
    statusMap?: Record<T[K] extends number ? number : string, StatusType>;
    prefix?: string;
  }>(),
  {
    prefix: '',
    status: 'neutral',
    statusMap: undefined,
  },
);

/**
 * get enum label with replacement
 */
const enumLabel = computed(() => {
  if (props.enumValue != null) {
    return getEnumLabel(props.enumMap, props.enumValue);
  }

  return '';
});

/**
 * get status by explicit status or implied by statusMap
 */
const status = computed<StatusType>(() => {
  if (props.statusMap != null && props.enumValue != null) {
    return props.statusMap[props.enumValue];
  }

  return props.status;
});
</script>

<template>
  <GpTag v-if="enumValue != null" :tag-type="status" :label="enumLabel" size="xs" />
</template>
